import { ActionButton } from './DiagramSelectionBar';
import { TRANSFORM_ACTIONS, type TransformOp } from './diagramTransform';

/**
 * Kleine Gruppe "Spiegeln/Drehen" unter der Zeichenflaeche: waagrecht und senkrecht spiegeln, um 90 Grad (im Uhrzeigersinn)
 * und um 180 Grad drehen. Gilt fuer die Auswahl; ist nichts markiert, fuer die ganze Skizze - dann tragen die Knoepfe
 * "Ganze Skizze ..." im Namen, damit niemand versehentlich alles dreht. Die Rechnung steht in `diagramTransform.ts`.
 */
export function TransformPanel({
  id,
  whole,
  disabled,
  onTransform,
}: {
  id?: string;
  /** Nichts markiert: die Knoepfe wirken auf die ganze Skizze. */
  whole: boolean;
  disabled?: boolean;
  onTransform: (op: TransformOp) => void;
}): JSX.Element {
  return (
    <section id={id} role="group" aria-label="Spiegeln und Drehen" data-testid="transform-panel" className="space-y-2 rounded-lg border border-slate-200 bg-white p-2">
      <div className="grid grid-cols-2 gap-1.5">
        {TRANSFORM_ACTIONS.map((action) => {
          const label = whole ? `Ganze Skizze ${action.label.charAt(0).toLowerCase()}${action.label.slice(1)}` : action.label;
          return (
            <ActionButton key={action.op} label={label} disabled={disabled} className="px-1" onClick={() => onTransform(action.op)}>
              {whole ? `Ganze Skizze: ${action.short.charAt(0).toLowerCase()}${action.short.slice(1)}` : action.short}
            </ActionButton>
          );
        })}
      </div>
      <p className="text-xs text-slate-500">
        {whole
          ? 'Nichts markiert: Die ganze Skizze wird um die Feldmitte gespiegelt oder gedreht. Text bleibt lesbar.'
          : 'Die Auswahl wird um ihre Mitte gespiegelt oder gedreht. Text bleibt lesbar.'}
      </p>
    </section>
  );
}
